import type { ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";

import { LoginSkeleton } from "../login/LoginSkeleton";
import { oidcSignIn } from "../login/authConfig";
import { getMe } from "../providers/api/client";
import { NoWorkspacePage } from "./NoWorkspacePage";

/**
 * In front of the app's layout (M4): a signed-in user with no workspace sees the "no workspace yet"
 * page instead of a dashboard that has nothing to load. Off in demo/Supabase mode.
 */
export const WorkspaceGate = ({ children }: { children: ReactNode }) => {
  const { data: me, isPending } = useQuery({
    queryKey: ["crm.me"],
    queryFn: getMe,
    enabled: oidcSignIn,
    retry: false,
  });
  if (!oidcSignIn) return <>{children}</>;
  if (isPending) return <LoginSkeleton />;
  if (me && me.memberships.length === 0) return <NoWorkspacePage me={me} />;
  // Errors (e.g. a 401) fall through: react-admin's auth handling deals with them.
  return <>{children}</>;
};
